/*
 * AccountReroll — titres de carte complets, jamais coupes par « … ».
 *
 * genshin-custom.css coupe les titres avec une ellipse, ce qui masquait le
 * serveur et l'archetype — justement ce que l'acheteur cherche. On reduit donc
 * la police plutot que de tronquer.
 *
 * NOMBRE DE LIGNES SELON L'ECRAN. Desktop : 2 lignes. Sous 750px : 4 lignes
 * (titres jusqu'a 89 caracteres, colonne de 156px) — le rendu du concurrent,
 * qui ne tronque jamais.
 *
 * LE CLAMP EST POSE EN INLINE (important), PAS EN CSS : genshin-custom.css a
 * plusieurs regles concurrentes en !important ; l'inline important les bat
 * toutes, et le script pose le nombre de lignes qu'il a utilise pour calculer.
 *
 * UNE SEULE TAILLE PAR GRILLE : la taille dont le titre le plus long a besoin,
 * appliquee au groupe entier ; chaque section est traitee a part.
 *
 * 03/10/2026 — VERSION RAPIDE, MEME RESULTAT. L'ancienne version coutait 10 s de
 * calcul sur un mobile moyen (profil Chrome, CPU /4) : pour chaque titre elle
 * essayait 17 tailles une par une, et chaque essai forcait la mise en page de
 * toute la page (4 400 noeuds), puis elle recommencait a chaque ajout dans la
 * page (Judge.me, chat, analytics). Desormais :
 *   1. LECTURE de toutes les largeurs d'abord, ECRITURE de tous les styles a la fin ;
 *   2. mesure dans une sonde isolee (contain: strict + Shadow DOM) : seule la sonde est recalculee ;
 *   3. recherche dichotomique (5 essais au lieu de 17) + memoire par texte/largeur/police ;
 *   4. on ne relance que si des cartes produits arrivent dans la page.
 */
(function () {
  if (window.__arTitre2Lignes) return;   // price.liquid est rendu une fois par carte
  window.__arTitre2Lignes = true;

  var MAX = 13, MIN = 9, PAS = 0.25, INTERLIGNE = 1.3;
  var SEUIL_MOBILE = 750, LIGNES_MOBILE = 4, LIGNES_DESKTOP = 2;
  var SEL = '.card__heading a, .card__heading .full-unstyled-link';
  var GRILLE = 'ul.grid, .grid, [id^="shopify-section"]';
  var NB = Math.round((MAX - MIN) / PAS);           // tailles possibles : MIN + k * PAS, k = 0..NB
  var boite = null, sonde = null, memoire = {};

  function lignesAutorisees() {
    return window.innerWidth < SEUIL_MOBILE ? LIGNES_MOBILE : LIGNES_DESKTOP;
  }

  function creeSonde() {
    // Boite de taille fixe et contain: strict = frontiere de mise en page :
    // mesurer la sonde ne remet en page que la boite, jamais le reste du document.
    // + Shadow DOM : les regles :has() du theme ne voient pas ce qui change dans la sonde, sinon chaque
    // essai de taille relancait le calcul de style de TOUTE la page (8 s par passage sur l'accueil mobile).
    boite = document.createElement('div');
    boite.setAttribute('aria-hidden', 'true');
    boite.style.cssText = 'position:absolute;left:-9999px;top:0;width:2000px;height:1000px;overflow:hidden;contain:strict;visibility:hidden;pointer-events:none;';
    var racine = boite.attachShadow ? boite.attachShadow({ mode: 'open' }) : boite;
    sonde = document.createElement('div');
    sonde.style.cssText = 'white-space:normal;line-height:' + INTERLIGNE + ';';
    racine.appendChild(sonde);
    document.body.appendChild(boite);
  }

  function tient(px, lignes) {
    sonde.style.fontSize = px + 'px';
    return sonde.offsetHeight <= px * INTERLIGNE * lignes + 1;
  }

  /** Plus grande taille, entre MIN et MAX (pas de 0,25), ou ce titre tient dans le nombre de lignes vise. */
  function tailleNecessaire(m, lignes) {
    var cle = m.texte + '|' + m.large + '|' + m.police + '|' + m.graisse + '|' + m.espace + '|' + lignes;
    if (memoire[cle] !== undefined) return memoire[cle];
    sonde.style.width = m.large + 'px';
    sonde.style.fontFamily = m.police;
    sonde.style.fontWeight = m.graisse;
    sonde.style.letterSpacing = m.espace;
    sonde.textContent = m.texte;
    var px;
    if (tient(MAX, lignes)) px = MAX;
    else {
      // le plus grand k tel que MIN + k*PAS tienne (tient() est monotone : plus petit = moins de lignes)
      var bas = 0, haut = NB - 1, trouve = -1;
      while (bas <= haut) {
        var mil = (bas + haut) >> 1;
        if (tient(MIN + mil * PAS, lignes)) { trouve = mil; bas = mil + 1; } else haut = mil - 1;
      }
      px = trouve < 0 ? MIN : MIN + trouve * PAS;
    }
    memoire[cle] = px;
    return px;
  }

  function ajuste() {
    var liens = document.querySelectorAll(SEL);
    if (!liens.length) return;
    if (!sonde) creeSonde();
    var lignes = lignesAutorisees();

    // 1. LECTURES seulement (une seule mise en page de la page)
    var grilles = new Map(), mesures = [];
    for (var i = 0; i < liens.length; i++) {
      var a = liens[i];
      if (!a.offsetHeight) continue;
      var large = a.parentElement.getBoundingClientRect().width;
      var cs = getComputedStyle(a);
      var m = { a: a, large: large, police: cs.fontFamily, graisse: cs.fontWeight, espace: cs.letterSpacing,
                texte: a.textContent.replace(/\s+/g, ' ').trim() };
      mesures.push(m);
      var g = a.closest(GRILLE) || document.body;
      if (!grilles.has(g)) grilles.set(g, []);
      grilles.get(g).push(m);
    }

    // 2. MESURES dans la sonde isolee
    var tailles = [];
    grilles.forEach(function (groupe) {
      var min = MAX;
      for (var i = 0; i < groupe.length; i++) {
        var px = groupe[i].large ? tailleNecessaire(groupe[i], lignes) : MAX;
        if (px < min) min = px;
      }
      tailles.push([groupe, min]);
    });

    // 3. ECRITURES, toutes a la fin
    for (var k = 0; k < tailles.length; k++) {
      var groupe = tailles[k][0], min = tailles[k][1];
      for (var j = 0; j < groupe.length; j++) {
        var el = groupe[j].a;
        el.style.setProperty('-webkit-line-clamp', String(lignes), 'important');
        // setProperty(..., 'important') : genshin-custom.css impose « font-size: inherit !important »
        if (min < MAX) el.style.setProperty('font-size', min + 'px', 'important');
        else el.style.removeProperty('font-size');
      }
    }
  }

  var minuteur;
  function planifie() { clearTimeout(minuteur); minuteur = setTimeout(ajuste, 120); }

  document.addEventListener('DOMContentLoaded', ajuste);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { memoire = {}; ajuste(); });
  else window.addEventListener('load', ajuste);
  window.addEventListener('resize', planifie);
  window.addEventListener('orientationchange', planifie);

  /*
   * Dawn recharge la grille en AJAX (filtres, tri, pagination) : on relance
   * seulement si les noeuds ajoutes contiennent des titres de carte (avant :
   * a chaque ajout dans la page, badges Judge.me et chat compris).
   */
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var ajoutes = muts[i].addedNodes;
        for (var j = 0; j < ajoutes.length; j++) {
          var n = ajoutes[j];
          if (n.nodeType !== 1 || n === boite) continue;
          if ((n.matches && n.matches(SEL)) || (n.querySelector && n.querySelector(SEL))) { planifie(); return; }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
